import { render, staticRenderFns } from "./PostBoostingWithoutConnect.vue?vue&type=template&id=8afac202&scoped=true&"
import script from "./PostBoostingWithoutConnect.vue?vue&type=script&lang=ts&"
export * from "./PostBoostingWithoutConnect.vue?vue&type=script&lang=ts&"
import style0 from "./PostBoostingWithoutConnect.vue?vue&type=style&index=0&id=8afac202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afac202",
  null
  
)

export default component.exports